// extracted by mini-css-extract-plugin
module.exports = {"typography_text":"tooltips_typography_text__1TiR_","tooltip_with_paragraphs":"tooltips_tooltip_with_paragraphs__1wAwv"};